import PlentyApiClient from "./base";

// Penner/Renner Rules API
export const pennerRennerApi = {
  // Get both penner and renner rules (thresholds)
  getRules: (type = "plenty") => {
    return PlentyApiClient.get("/plenty/penner-renner-rules/", {
      params: { type },
    });
  },

  // Update the threshold value for a rule (either 'penner' or 'renner')
  updateRule: (ruleName, thresholdValue, type = "plenty") => {
    return PlentyApiClient.put(`/plenty/penner-renner-rules/${ruleName}`, {
      threshold_value: thresholdValue,
      type,
    });
  },

  // Categorize articles as penner, renner, or neutral
  categorizeArticles: (articleRatios, type = "plenty") => {
    // articleRatios: [{ article_id: string, ratio: number }, ...]
    return PlentyApiClient.post("/plenty/articles/categorize", {
      article_ratios: articleRatios,
      type,
    });
  },
};
